import { app } from '../../app.module'
/**
 * 日を選択するフォーム。選択した場合は、親スコープにイベントを送信する
 * attribute: なし
 */
class DayFormComponentCtrl {
  private scope: ng.IScope
  private label: string
  private days: (string | number)[]
  private date: string | number

  constructor($scope) {
    this.scope = $scope

    this.label = '日'
    this.days = this.setDays('1')

    // デフォルトの値をイベント送信する
    this.scope.$emit('selectDay', 1)

    // 月が変更された場合は、日一覧を変更し、1日で初期化する
    this.scope.$on('changeMonth', (event, month) => {
      this.days = this.setDays(month)
      this.date = 1
      this.scope.$emit('selectDay', 1)
    })
    // 編集としてモーダルが呼ばれた際は、既存のタグをセットする
    this.scope.$on('setEventData', (event, eventData) => {
      if (eventData.date === 97) {
        this.date = '上旬'
      } else if (eventData.date === 98) {
        this.date = '中旬'
      } else if (eventData.date === 99) {
        this.date = '下旬'
      } else {
        this.date = eventData.date
      }
    })
  }

  /**
   * 選択した日をイベント送信する
   * @param  {string} selectedDay
   */
  public selectDay(selectedDay: string) {
    if (selectedDay === '上旬') {
      selectedDay = '97'
    }
    if (selectedDay === '中旬') {
      selectedDay = '98'
    }
    if (selectedDay === '下旬') {
      selectedDay = '99'
    }

    // イベントをemitする
    this.scope.$emit('selectDay', selectedDay)
  }

  /**
   * 日一覧をセットする
   * @param  {number} month 選択月
   */
  private setDays(month: string) {
    let daysCount: number
    switch (Number(month)) {
      case 4:
      case 6:
      case 9:
      case 11:
        daysCount = 30
        break
      case 2:
        daysCount = 29
        break
      default:
        daysCount = 31
        break
    }

    // 配列に日を格納して返す
    const result = []

    for (let i = 1; i <= daysCount; i = i + 1) {
      result.push(i)
    }
    result.push('上旬', '中旬', '下旬')

    return result
  }
}

app.component('dayForm', {
  template: require('./day-form.pug')(),
  controller: DayFormComponentCtrl,
})
